// extracted by mini-css-extract-plugin
export default {"backgroundMode":"ElencoUtenti_backgroundMode__Clwzs","stileFont":"ElencoUtenti_stileFont__6Z7Vd","stileFontObbligatorieta":"ElencoUtenti_stileFontObbligatorieta__I9Yh7"};